import { render, staticRenderFns } from "./FormPasswordRecovery.vue?vue&type=template&id=cfbe8642&"
import script from "./FormPasswordRecovery.vue?vue&type=script&lang=ts&"
export * from "./FormPasswordRecovery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports